<template>
  <div class="horizontal layout center votecount-v2">
    <div
      class="mr-0 count-answer"
      v-tooltip="tooltip"
    >
      <i :class="iconClasses" aria-hidden="true" />
      <span
        class="count-answer-number"
      >{{ voteCount | formatTotalPoint }}
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import VoteCount from './VoteCount.vue'

const voterTooltip = (i18n, count) => {
  return count == 1
    ? i18n.t('x voter', { x: count })
    : i18n.t('x voters', { x: count })
}

const answerCountTooltip = (i18n, count) => {
  return count == 1
    ? i18n.t('x answer', { x: count })
    : i18n.t('x answers', { x: count })
}

export default {
  extends: VoteCount,
  computed: {
    ...mapGetters(['currentSlideType']),
    ...mapGetters('liveStatsV2', [
      'answerCountPerActivity',
      'answererCountPerQuestion',
      'pollVoteCount',
      'scaleVoteCount',
      'wordCloudVoteCount',
    ]),
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    tooltipMap() {
      return {
        poll: voterTooltip(this.$i18nPresenter, this.voteCount),
        scales: voterTooltip(this.$i18nPresenter, this.voteCount),
        wordCloud: answerCountTooltip(this.$i18nPresenter, this.voteCount),
      }
    },
    voteCountMap() {
      return {
        poll: this.pollVoteCount,
        scales: this.scaleVoteCount,
        wordCloud: this.wordCloudVoteCount,
      }
    },
    voteCount() {
      if (this.voteCountMap[this.currentSlideType]) {
        return this.voteCountMap[this.currentSlideType] || 0
      }
      return 0
    },
    tooltip() {
      if (this.tooltipMap[this.currentSlideType]) {
        return this.tooltipMap[this.currentSlideType]
      }
      return ''
    },
    iconClasses() {
      return this.getIconClasses(this.currentSlideType)
    },
  },
  methods: {
    getIconClasses() {
      return 'fas fa-hand-paper fa-fw'
    },
  },

}
</script>
